import React, { Component } from 'react';
import style from './Paging.module.css';

class Paging extends Component {
    render() {
        let dataObject = this.props.dataObject;
        //console.log(dataObject);

        let page = dataObject.page;
        let totalPage = dataObject.totalPage;
        let totalRecord = dataObject.totalRecord;
        //let perPage = dataObject.perPage;
        let skipRecord = dataObject.skipRecord;


        let fromRecord = 0;
        let toRecord = 0;
        if(totalRecord>0){
            fromRecord =  skipRecord+1;
            toRecord = dataObject.dataList.length;
        }
        
        let infoMessage = "Showing "+ fromRecord +" to " +toRecord+ " of " +totalRecord+ " entries ";


         let startBtn = page-5;
         if(startBtn<1) startBtn = 1;

         let endBtn = page+5;
         if(endBtn>totalPage)endBtn=totalPage;
          
        let btnItem = [];



        if(startBtn>1){
            if(page === 1){
                btnItem.push(
                    <div className={style.pagingBtnActive} key={1} onClick={(e)=>this.props.onClick(1)}>1</div>
                );
            }
            else{
                btnItem.push(
                    <div className={style.pagingBtn} key={1} onClick={(e)=>this.props.onClick(1)}>1</div>
                );
            }
            
        }
        for(let i= startBtn;i<=endBtn;i++){

            if(page === i){
                btnItem.push(
                    <div className={style.pagingBtnActive} key={i} onClick={(e)=>this.props.onClick(i)}>{i}</div>
                );
            }else{
                btnItem.push(
                    <div className={style.pagingBtn} key={i} onClick={(e)=>this.props.onClick(i)}>{i}</div>
                );
            }
        }
        if(endBtn<totalPage){
            if(page === totalPage){
                btnItem.push(
                    <div className={style.pagingBtnActive} key={totalPage} onClick={(e)=>this.props.onClick(totalPage)}>{totalPage}</div>
                );
            }
            else{
                btnItem.push(
                    <div className={style.pagingBtn} key={totalPage} onClick={(e)=>this.props.onClick(totalPage)}>{totalPage}</div>
                );
            }
        }




        return (
            <div className={style.pagingArea}>
                <div className={style.pagingInfo}>{infoMessage}</div>
                <div className={style.pagingBtnArea}>
                    {/* <div className={style.pagingBtn}>1</div>
                    <div className={style.pagingBtnActive}>2</div>
                    <div className={style.pagingBtn}>3</div> */}
                    {btnItem}
                </div>
            </div>
        );
    }
}
export default Paging;
